import { useAdminCargoListPageProps } from "./fetch";
import { AdminCargoListPageUi } from "./ui";

export const AdminCargoListPage = () => {
  const props = useAdminCargoListPageProps();
  return <AdminCargoListPageUi {...props} />;
};
